import {acceptedCardTypes} from 'configs/payment'
import {filter, includes} from 'ramda'

import {CreditCard} from '@daedalus/core/src/booking/services/paymentOptionsApi'

export const filterCards = (cards: CreditCard[]): CreditCard[] => {
  return filter(card => includes(card.code, acceptedCardTypes), cards)
}
